import React from "react";
import styles from "./Input.module.css";

function Input(props) {
  return (
    <input id={props.id} type={props.type || 'text'} className={styles.input} placeholder={props.placeholder} onChange={props.onChange} />
  );
}

export default Input;